/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />

module App.HiLO.Services {
    'use strict';

    export class ReferenceNumberService {


        public static $inject = [
            '$q',
            'app.common.services.apiService'

        ];

        private prefix: string = 'HILO';
        private nextSeq: string;

        constructor(private $q: angular.IQService, private api: Common.Services.ApiService) {

        }

        public getReferenceNumber(productLetter: string): angular.IPromise<any> {
            var deferred = this.$q.defer();
            this.getNextSequence().then(() => {
                var referenceNumber = this.prefix + '/' + productLetter + '/' + this.getYear() + '/' + this.nextSeq;
                deferred.resolve(referenceNumber);
            });
            return deferred.promise;
        }

        private getNextSequence(): angular.IPromise<any> {


            return this.api.get({
                resourceName: 'SequenceNumber'
            })
                .then((data: number): void => {
                    this.nextSeq = data.toString();
                });



        }

        private getYear(): string {
            var d = new Date();

            return d.getFullYear().toString().substr(2, 3);

        }

    }

    angular
        .module('app.hilo.services')
        .service('app.hilo.services.referenceNumberService', ReferenceNumberService);
}